module.exports = __webpack_public_path__ + "media/莫文蔚 Karen Mok《這世界那麼多人 Empty World》Official MV - 電影「我要我們在一起」主題曲.6fdc14fc.mp3";